import { useOutletContext } from "react-router";
import type { OnboardingSharedState } from "./OnboardingLayout";

/** The chart and email shared between steps; only valid under <OnboardingLayout>. */
export function useOnboardingShared(): OnboardingSharedState {
  return useOutletContext<OnboardingSharedState>();
}
